import {
  AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, input, OnDestroy, Output
} from "@angular/core";
import {NavbarService} from "./navbar.service";


@Component({
  template: ''
})
export abstract class ItemBase implements AfterViewInit, OnDestroy {
  /**
   * Obtained with `inject()` rather than as a constructor parameter **on purpose**. There is an import cycle
   * here: `navbar.service.ts` imports the navbar item components, which import this base, which needs the
   * service back. A constructor parameter makes Angular emit `NavbarService` into this class's compiled
   * factory — a reference evaluated while the module graph is still initialising — so whichever module is
   * pulled in first can trip `Cannot access 'NavbarService' before initialization`. `inject()` resolves at
   * construction time instead, leaving the cycle harmless whatever the entry point is (the app, a spec, or a
   * Storybook chunk — the last of which is how it surfaced).
   */
  private readonly navbarService = inject(NavbarService);

  constructor() {
    this.navbarService.itemBases.push(this);
  }

  ngOnDestroy(): void {
    this.navbarService.itemBases.splice(this.navbarService.itemBases.indexOf(this), 1);
  }

  ngAfterViewInit(): void {
    this.breadcrumbs.splice(0, 0, this.title);
    let ne = this.item.nativeElement;
    while (ne.parentElement != undefined && ne.nodeName != "APP-NAVBAR-OFFICE-ITEM") {
      if (ne.getAttribute("breadcrumb")) {
        this.breadcrumbs.splice(0, 0, ne.getAttribute("breadcrumb"));
      }
      ne = ne.parentElement;
    }
  }

  abstract item: ElementRef;

  /**
   * Optional status badge rendered beside the entry's label — `badge="Beta"`, `badge="Neu"`, …
   *
   * Deliberately a **free-text label, not a boolean** `beta` flag: flagging the next entry (a preview, a
   * deprecation, a pilot) must be a template attribute, never another change to this component (#224). Leave it
   * unset (the default) for an ordinary entry.
   *
   * The badge is real, visible text and sits **after** the title in DOM order, so a screen reader announces the
   * entry as "Formulare Beta" — the status is never carried by colour or position alone.
   */
  readonly badge = input<string | null>(null);

  @Input() title: string = "Button";
  @Input() link: any[] | string | null | undefined;
  @Input() params: any = {};
  @Input() onSelectedFunction: boolean = false;
  @Output() onSelected: EventEmitter<number> = new EventEmitter<number>();

  breadcrumbs: string[] = [];

  get id(): string {
    return this.breadcrumbs.join(" → ");
  }

  get value(): string {
    return this.breadcrumbs.slice(1).join(" → ");
  }

  contains(term: string): boolean {
    return this.id.toLowerCase().indexOf(term.toLowerCase()) > -1;
  }

  execute() {
    this.onSelected.next(Math.random())
  }
}
